import { IColumnsItem } from '@/components/custom-table/type.d';
import { filters } from '@/core/plugins/filter';
import { IZoneParseLogListResListItem, ZONE_LOG_TYPE_LIST } from '@/api/domain-system/type';

export const renderColumns = (): IColumnsItem<IZoneParseLogListResListItem>[] => [
  {
    label: '域名',
    prop: 'zoneName',
    ellipsis: true,
  },
  {
    label: '主机记录',
    prop: 'rr',
    ellipsis: true,
  },
  {
    label: '操作类型',
    render: row => <div>{ZONE_LOG_TYPE_LIST.filter(n => n.value === row.type)[0].label}</div>,
  },
  {
    label: '内容',
    prop: 'content',
    ellipsis: true,
  },
  {
    label: '备注',
    prop: 'remark',
    ellipsis: true,
  },
  {
    label: '操作人',
    prop: 'creatorName',
  },
  {
    label: '操作时间',
    render: row => <div>{filters.formatTime(row.createdTime)}</div>,
  },
];
